import { render, staticRenderFns } from "./UiTextbox.vue?vue&type=template&id=1b62ee5b&scoped=true"
import script from "./UiTextbox.vue?vue&type=script&lang=js"
export * from "./UiTextbox.vue?vue&type=script&lang=js"
import style0 from "./UiTextbox.vue?vue&type=style&index=0&id=1b62ee5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b62ee5b",
  null
  
)

export default component.exports